<template>
  <BaseNumberInput
    v-bind="$attrs"
    :hide-details="hideDetails"
    :model-value="modelValue"
    :is-raw-format="isRawFormat"
    :format-type="NumberInputEnum.integer"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { NumberInputMixin } from '@/bundles/Common/mixins/NumberInputMixin';

import BaseNumberInput from '@/bundles/Common/components/inputs/BaseNumberInput.vue';

export default defineComponent({
  name: 'IntegerInput',

  components: { BaseNumberInput },
  mixins: [NumberInputMixin],

  props: {
    isRawFormat: Boolean,
  },

  emits: ['update:modelValue'],

});
</script>
